import PropTypes from 'prop-types';
import { SelectSearch } from 'mol-ui';
import clone from 'lodash/clone';
import { turnsActions } from 'core/Turns';
import { useTranslation } from 'react-i18next';
import React, { useEffect } from 'react';
import {
    useDispatch,
    useSelector
} from 'hooks';

const AppointmentTypePicker = ({
    allowAll,
    disabled,
    doctorId,
    nullPlaceholder,
    onChange = () => null,
    objectChange,
    placeholder,
    specialtyId,
    type,
    value
}) => {

    const dispatch = useDispatch();
    const { t } = useTranslation();
    const {
        appointmentTypes,
        appointmentTypesLoading: loading
    } = useSelector('turns');

    useEffect(() => {
        const params = {
            ...(doctorId && { doctor_id: doctorId }),
            ...(specialtyId && !doctorId && { specialty_id: specialtyId }),
            ...(type && { type })
        };
        dispatch(turnsActions.getAppointmentTypes(params));
    }, [doctorId, specialtyId, type]);

    const handleChange = value => {
        if (!objectChange) {
            onChange(value);
        } else {
            const appointmentType = appointmentTypes.find(({ id }) => id === value);
            onChange(appointmentType);
        }
    };
    
    const options = clone(appointmentTypes);
    if (allowAll) {
        options.unshift({ label: nullPlaceholder ? nullPlaceholder : t('Cualquier motivo'), value: 0 });
    }

    return (
        <SelectSearch
            material
            disabled={ disabled || loading }
            fontSize="14px"
            margin="0px"
            options={ options }
            placeholder={ placeholder ? placeholder : t('Seleccione un motivo') }
            value={ value }
            width="100%"
            onChange={ handleChange }
        />
    );
};

AppointmentTypePicker.propTypes = {
    allowAll: PropTypes.bool,
    disabled: PropTypes.bool,
    doctorId: PropTypes.string,
    nullPlaceholder: PropTypes.string,
    objectChange: PropTypes.func,
    onChange: PropTypes.func,
    placeholder: PropTypes.string,
    specialtyId: PropTypes.string,
    type: PropTypes.string,
    value: PropTypes.string
};

export default AppointmentTypePicker;
